import React from 'react';
import type { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import { useWindowSize } from '@uidotdev/usehooks';
import { Box } from '@chakra-ui/react';

import Layout from '@/components/Layout';
import NewsletterDetailsLayout from '@/containers/newsletter/NewsletterDetailsLayout';
import { INewsletterData, NEWSLETTER_DATA } from '@/constants/pages/newsletter';
import Footer from '@/components/Footer';

const NewsletterDetails: NextPage<{ newsletterData: INewsletterData }> = ({
  newsletterData,
}) => {
  const { width } = useWindowSize();

  return (
    <Layout
      hideFooter={Boolean(width && width < 700)}
      url=""
      ogTitle="Newsletter"
      title="Newsletter"
      keywords="IVCA"
    >
      <>
        <NewsletterDetailsLayout newsletterData={newsletterData} />
        {width && width < 700 && (
          <Box width="640px">
            <Footer />
          </Box>
        )}
      </>
    </Layout>
  );
};

export default NewsletterDetails;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { year, month } = ctx.query;

  if (typeof month !== 'string') {
    return { notFound: true };
  }

  const currNewsletter = NEWSLETTER_DATA?.find(
    (item) => item?.month === month && item?.year === year
  );

  if (currNewsletter) {
    return {
      props: {
        newsletterData: currNewsletter,
      },
    };
  }
  return { notFound: true };
};
